import { useSyncExternalStore } from "react";

export const CONTENT_LANGUAGE_HEADER = "x-kabel-language";
export const CONTENT_LANGUAGE_STORAGE_KEY = "kabel-admin-content-language";

export type ContentLanguage = "en" | "cn";

const changeEvent = "kabel:content-language-change";

function readStoredLanguage(): ContentLanguage {
  if (typeof window === "undefined") return "en";
  try {
    return window.localStorage.getItem(CONTENT_LANGUAGE_STORAGE_KEY) === "cn"
      ? "cn"
      : "en";
  } catch {
    return "en";
  }
}

let currentLanguage = readStoredLanguage();

export function getContentLanguage(): ContentLanguage {
  return currentLanguage;
}

export function setContentLanguage(language: ContentLanguage): void {
  if (currentLanguage === language) return;
  currentLanguage = language;
  try {
    window.localStorage.setItem(CONTENT_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Storage may be unavailable in restrictive browsing modes.
  }
  window.dispatchEvent(new Event(changeEvent));
}

function subscribe(callback: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== CONTENT_LANGUAGE_STORAGE_KEY) return;
    currentLanguage = event.newValue === "cn" ? "cn" : "en";
    callback();
  };
  window.addEventListener(changeEvent, callback);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(changeEvent, callback);
    window.removeEventListener("storage", onStorage);
  };
}

export function useContentLanguage(): ContentLanguage {
  return useSyncExternalStore(subscribe, getContentLanguage, () => "en");
}
